import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";

const ItemContent = ({ info }) => {
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Flex>
      <Text color={textColor} fontSize="sm">
        {info}
      </Text>
    </Flex>
  );
};

export default ItemContent;
